import RenderConsommation from "./renderConsommation";
import RenderMateriel from "./renderMateriel";
import RenderPersonnel from "./renderPersonnel";

const RenderModifLine = ({ sub, detail, setDetails, parentId, subcategories }: { sub: any, detail: any, setDetails: any, parentId: any, subcategories: any }) => {
    return (
        <>
            <div key={sub.rpl_id} className={`card_modifPresta category_container`}>
                <div className="header_cardModifPresta">
                    <p>{sub.rpl_designation}</p>
                </div>
                <div className="linePresta">
                    {sub.v_materiel && <RenderMateriel sub={sub} details={detail} setDetails={setDetails} parentId={parentId} isValid={subcategories.isValid} />}
                    {sub.v_consommation && <RenderConsommation sub={sub} details={detail} setDetails={setDetails} parentId={parentId} isValid={subcategories.isValid} />}
                    {sub.v_reserve && <RenderConsommation sub={sub} details={detail} setDetails={setDetails} parentId={parentId} isValid={subcategories.isValid} />}
                    {sub.v_personnel && <RenderPersonnel sub={sub} details={detail} setDetails={setDetails} parentId={parentId} isValid={subcategories.isValid}></RenderPersonnel>}
                </div>
            </div>
        </ >
    );
};
export default RenderModifLine